import store from '@polleverywhere/redux'
import { slice as appSlice } from './../slices/app'

export default async function notFound (state, appOptions) {
  const AdvisoryMessage = (await import(/* webpackChunkName: 'advisory-message' */ '@polleverywhere/toolkit/components/advisory_message')).default

  const { role } = store.getState()[appSlice.name]

  const authRole = role === 'auth'
  const resolutionLabel = authRole ? 'Close' : 'Go home'

  const view = new AdvisoryMessage({
    icon: 'error',
    subject: 'Page not found',
    resolutionLabel
  })

  view.on('resolve', () => {
    if (authRole) {
      window.close()
    } else {
      store.dispatch(appSlice.pageUpdatedToDefault())
    }
  })

  return view
}
